// extracted by mini-css-extract-plugin
export default {"wrapper":"ManageOrganizationArtistsPopupFormStep_wrapper__7Sn95"};